// extracted by mini-css-extract-plugin
export default {"pen":"RemarksDetails_pen__7MoCm","trash":"RemarksDetails_trash__ltBsr","remark":"RemarksDetails_remark__IxBq1"};